function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import _ from 'underscore';

var Renewal = function Renewal(data) {
    _classCallCheck(this, Renewal);

    _.extend(this, data);
};

export default Renewal;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-renewal-js/models/Renewal.js
// module id = 153
// module chunks = 0